import { useMemo } from "react";

/**
 * Determines if a node is currently selected in the org chart panel
 * @param {Object} state - The org chart state object
 * @param {string} entityId - The ID of the entity (team id or person aggregateId)
 * @returns {boolean} Whether the node is selected
 */
export const useNodeSelection = (state, entityId) => {
  return useMemo(() => {
    return state?.expandedPanel?.data?.selectedEntity === entityId;
  }, [state?.expandedPanel?.data?.selectedEntity, entityId]);
};
